module.exports = __webpack_public_path__ + "img/logo_drogues_et_societe.95d33c16.png";